import script from "./WidgetExterno.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetExterno.vue?vue&type=script&setup=true&lang=js"

import "./WidgetExterno.vue?vue&type=style&index=0&id=2140ad4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2140ad4c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInfiniteScroll,QChatMessage,QIcon,QCircularProgress,QInput});
